import {
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { NEW_ZONE_TYPE_I18N_KEYS } from "./panels/details/NewZoneDetails";
import { NewZoneKind, startNewZone } from "portal/state/farmExplorer";
import { SMALL_BUTTON } from "portal/theme/theme";
import { useDispatch } from "react-redux";
import { useMuiColor } from "common/hooks/useMuiColor";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import BoundaryIcon from "portal/images/icons/fence.svg?react";
import ObstacleIcon from "portal/images/icons/obstacle.svg?react";
import PivotIcon from "common/images/icons/irrigation.svg?react";
import React, { FC, ReactNode, useState } from "react";

interface NewZoneMenuProps {
  // a farm has one boundary; offer it only while there is none
  boundaryPresent: boolean;
}

/** The one place to start adding geometry: a "New" button with the kinds. */
export const NewZoneMenu: FC<NewZoneMenuProps> = ({ boundaryPresent }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const textColor = useMuiColor("textPrimary");
  const [anchor, setAnchor] = useState<HTMLElement>();

  const iconClass = "w-5 h-5";
  const icons: Record<NewZoneKind, ReactNode> = {
    farmBoundary: (
      <BoundaryIcon className={iconClass} style={{ fill: textColor }} />
    ),
    obstacle: (
      <ObstacleIcon className={iconClass} style={{ fill: textColor }} />
    ),
    centerPivot: (
      <PivotIcon className={iconClass} style={{ fill: textColor }} />
    ),
  };
  const kinds: NewZoneKind[] = boundaryPresent
    ? ["obstacle", "centerPivot"]
    : ["farmBoundary", "obstacle", "centerPivot"];

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        endIcon={<ArrowDropDownIcon />}
        {...SMALL_BUTTON}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {t("utils.actions.new")}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(undefined)}
      >
        {kinds.map((kind) => (
          <MenuItem
            key={kind}
            onClick={() => {
              setAnchor(undefined);
              dispatch(startNewZone(kind));
            }}
          >
            <ListItemIcon>{icons[kind]}</ListItemIcon>
            <ListItemText>{t(NEW_ZONE_TYPE_I18N_KEYS[kind])}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
